import Axios, { AxiosError, type AxiosRequestConfig } from 'axios';

export const AXIOS_INSTANCE = Axios.create({
	baseURL: import.meta.env.VITE_API_BASE_URL,
	withCredentials: true
});

export const customInstance = <T>({ signal, ...config }: AxiosRequestConfig): Promise<T> => {
	const source = Axios.CancelToken.source();
	const promise = AXIOS_INSTANCE({
		...config,
		cancelToken: source.token,
		...(signal ? { signal } : {})
	}).then(({ data }) => data);

	// @ts-expect-error - promise.cancel is not typed
	promise.cancel = () => {
		source.cancel('Query was cancelled');
	};

	return promise;
};

export type ErrorType<T> = AxiosError<T, T>;
